import * as React from 'react';
import './ScoresLabels.scss';

export interface IScoresLabelsProps {
  scores: string[];
}

const ScoresLabels: React.FC<IScoresLabelsProps> = ({ scores }) => {
  const fraction = 100 / scores.length;
  const scoresLabels = scores.map((score, index) => {
    const style = {
      top: 'calc((' + fraction * index + '%) - var(--label-height) / 2)',
    };

    return (
      <div key={index} className="scores-label" style={style}>
        {score}
      </div>
    );
  });

  return <div className="scores-labels-container">{scoresLabels}</div>;
};

export default ScoresLabels;
